"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("./parse");
var TextResolver = /** @class */ (function () {
    function TextResolver(book, config) {
        'ngInject';
        this.defaultText = '[...]';
        this.book = book;
        this.config = config;
        this.lang = this.config.params.langBook;
    }
    /**
     * This function is directly called in the book texts to resolve 'magic' texts.
     * It can be called with variable number of parameters which all must be strings
     * @param option one or more strings, first parameter defines the functionality
     * @return the resulting string or '' if not successful
     */
    TextResolver.prototype.resolve = function (option) {
        var options = Array.prototype.slice.call(arguments); //convert magic arguments array to real array
        // language specific commands
        if (this.lang === 'de') {
            switch (options[0]) {
                case 'besitz': // besitzanzeigendes s oder '
                    var value = options[1] !== '' ? options[1] : '[...]';
                    var last = value.substr(-1);
                    return value + (/[sśxzźżß]/i.test(value.substr(-1)) ? "'" : 's');
                case 'artikelLand': // Sonderfall LAND 1
                    return this.artikelLand(options[1], options[2]);
                case 'genusLand': //Sonderfall LAND 2
                    return this.genusLand(options[1]);
                case 'artikelVerein': //Sonderfall VEREIN
                    return this.artikelVerein(options[1], options[2]);
                default:
            }
        }
        else if (this.lang === 'fr') {
            switch (options[0]) {
                case 'konjugiertGeschlecht': //geschlechts-konjugiertes Adjektiv
                    var adjectiv = options[1] !== '' ? options[1] : '[...]';
                    var result = adjectiv;
                    if (options[2] === 'weiblich') {
                        var last = adjectiv.substr(-1);
                        if (last === 'x') {
                            var firstChunk = adjectiv.slice(0, -1);
                            result = firstChunk + 'se';
                        }
                        else {
                            result = adjectiv + 'e';
                        }
                    }
                    if (options[3] === 'plural') {
                        result += 's';
                    }
                    return result;
                case 'initialVokalSpezialY': //prüft auf ersten Vokal und auf Y gefolgt von Konsonant
                    var regex = /^[aàáâãäåąæeèéêëęiìíîïoòóôõöøœuùúûüh]|^[yÿ][bcćçdfghklłmnńñpqrstvwxzźżß]/i;
                    return regex.test(options[1]);
                default:
            }
        }
        else if (this.lang === 'it') {
            switch (options[0]) {
                case 'demonstPron': //geschlechts-konjugiertes Pronomen
                    var pronoun = options[1], noun = options[2] !== '' ? options[2] : '[...]';
                    return pronoun
                        .slice(0, -1)
                        .concat(/[aàáâãäåąæ]/i.test(noun.slice(0, 1)) ? "'" : noun.substr(-1));
                default:
            }
        }
        // language independent commands
        switch (options[0]) {
            case 'wert':
                return this.getWert(options[1], options[2]);
            case 'vergleich': //vergleicht zwei strings und gibt true oder false zurück
                return options[1] === options[2];
            case 'ungleich': //vergleicht zwei strings und gibt true oder false zurück
                return options[1] !== options[2];
            case 'enthaelt': //ob String1 in String2 enthalten, case insensitive
                return (String(options[2])
                    .toLowerCase()
                    .indexOf(String(options[1]).toLowerCase()) >= 0);
            case 'und': //logische und-Verknüpfung
                return options[1] && options[2];
            case 'oder': //logische oder-Verknüpfung
                for (var i = 1; i < options.length; ++i) {
                    if (options[i]) {
                        return true;
                    }
                }
                return false;
            case 'wedernoch': //beide Argumente false?
                return !options[1] && !options[2];
            case 'kleiner': //cast als number, ist zahl1 kleiner als zahl2?
                return parseInt(options[1], 10) < parseInt(options[2], 10);
            case 'groesser': //cast als number, ist zahl1 größer als zahl2?
                return parseInt(options[1], 10) > parseInt(options[2], 10);
            case 'versal': // erster Buchstabe groß
                var versal = options[1];
                return versal.substr(0, 1).toUpperCase() + versal.substr(1);
            case 'allesversal': // alle Buchstaben groß
                return options[1].toUpperCase();
            case 'klein': // alle Buchstaben klein
                var klein = options[1]; //TODO: check back: only the 1st char should be lowercased?
                return klein.substr(0, 1).toLowerCase() + klein.substr(1);
            case 'initial': // gibt nur den ersten Buchstaben in Großbuchstaben zurück
                var initial = options[1];
                return initial === '[...]'
                    ? initial
                    : initial.substr(0, 1).toUpperCase();
            case 'initialVokal': // gibt true zurück, wenn der erste Buchstabe ein Vokal ist
                var regex = this.lang === 'fr'
                    ? /^[aàáâãäåąæeèéêëęiìíîïoòóôõöøœuùúûüh]/i
                    : /^[aàáâãäåąæeèéêëęiìíîïoòóôõöøœuùúûü]/i;
                return regex.test(options[1]);
            case 'castnum': // extrahiert die erste Zahl am Anfang des Strings
                var castnum = options[1].match(/\d*/);
                return options[1] === this.defaultText || castnum[0] === ''
                    ? this.defaultText
                    : castnum[0];
            case 'laenge': // liefert Länge der Zeichenkette
                return options[1] === this.defaultText ? '0' : options[1].length;
            case 'numPlural': // gibt bei 1 'singular' zurück, sonst 'plural'
                var numPlural = parseInt(options[1], 10);
                return numPlural === 1 ? 'singular' : 'plural';
            case 'artikelLand': // Sonderfall LAND 1
                return this.artikelLand(options[1], options[2]);
            case 'genusLand': //Sonderfall LAND 2
                return this.genusLand(options[1]);
            case 'artikelVerein': //Sonderfall VEREIN
                return this.artikelVerein(options[1], options[2]);
            case 'optionaleStringsAufzaehlen': //gibt nur die definierten Strings zurück
                return this.optionaleStringsAufzaehlen(options[1]);
            case 'optionaleStringsArray': //gibt nur die definierten Strings zurück
                return options[1].filter(function (element) { return element !== ''; });
            default:
                return this.getFromTextMapping(options);
        }
    };
    /**
     * Text lookup in resolve.json by accessing the keys in the nested structure.
     * @param keyList the keys to use as accessing
     * @return the text value found by the key combination
     */
    TextResolver.prototype.getFromTextMapping = function (keyList) {
        var foundObject = this.config.localeJson.textresolve;
        for (var i = 0; i < keyList.length; ++i) {
            foundObject = foundObject[keyList[i]];
            if (foundObject === undefined) {
                return '[...]';
            }
        }
        return foundObject.toString();
    };
    /**
     * Gets text value of a property (option).
     * @param topLevProp top level property to get the property from
     * @param property the property to the text value from
     * @return the option's text value
     */
    TextResolver.prototype.getWert = function (topLevProp, property) {
        var value = this.book[topLevProp][property];
        var allPropValues = this.config.forms[topLevProp][property].options;
        var optionData = allPropValues.find(function (element, index, array) {
            return element.value === value;
        });
        return optionData ? parse_1.interpolate(optionData.$textValue, this.book) : value;
    };
    /**
     *
     */
    TextResolver.prototype.artikelLand = function (kasus, name) {
        name = name.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
        var republik = /(republik)/i;
        var femaleName = /^(usa|niederlande|niderlande|elfenbeinküste|elfenbeinkueste|schweiz|ukraine|türkei|tuerkei)$/i;
        var maleName = /^(iran|irak|kongo|senegal)$/i;
        if (republik.test(name)) {
            if (kasus === 'nominativ') {
                name = 'die ' + name;
            }
            else if (kasus === 'akkusativ') {
                name = 'die ' + name;
            }
            else if (kasus === 'genitiv') {
                var exploded = name.split(' ');
                for (var i = 0; i < exploded.length; i++) {
                    if (republik.test(exploded[i])) {
                        break;
                    }
                    exploded[i] += 'n';
                }
                name = 'der ' + exploded.join(' ');
            }
        }
        else if (femaleName.test(name)) {
            if (kasus === 'nominativ') {
                name = 'die ' + name;
            }
            else if (kasus === 'akkusativ') {
                name = 'die ' + name;
            }
            else if (kasus === 'genitiv') {
                name = 'der ' + name;
            }
        }
        else if (maleName.test(name)) {
            if (kasus === 'nominativ') {
                name = 'der ' + name;
            }
            else if (kasus === 'akkusativ') {
                name = 'den ' + name;
            }
            else if (kasus === 'genitiv') {
                name = 'des ' + name;
            }
        }
        else {
            if (kasus === 'genitiv') {
                name = 'von ' + name;
            }
        }
        return name;
    };
    /**
     * TODO: Description
     */
    TextResolver.prototype.artikelVerein = function (kasus, name) {
        name = name.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
        var maleName = /^[0-9]/;
        if (maleName.test(name)) {
            if (kasus === 'nominativ') {
                name = 'der ' + name;
            }
            else if (kasus === 'akkusativ') {
                name = 'den ' + name;
            }
            else if (kasus === 'genitiv') {
                name = 'des ' + name;
            }
        }
        else {
            if (kasus === 'genitiv') {
                name = 'von ' + name;
            }
        }
        return name;
    };
    /**
     * TODO: Description
     */
    TextResolver.prototype.genusLand = function (name) {
        name = name.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
        var republik = /(republik)/i;
        var femaleName = /^(usa|niederlande|niderlande|elfenbeinküste|elfenbeinkueste|schweiz|ukraine|türkei|tuerkei)$/i;
        if (republik.test(name) || femaleName.test(name)) {
            return 'ihrer';
        }
        else {
            return 'seiner';
        }
    };
    TextResolver.prototype.optionaleStringsAufzaehlen = function (names) {
        var condensed = names.filter(function (element) { return element !== ''; });
        if (condensed.length === 0) {
            return '';
        }
        else if (condensed.length === 1) {
            return condensed[0];
        }
        else {
            return condensed.slice(0, -1).join(', ') + ' und ' + condensed.slice(-1);
        }
    };
    return TextResolver;
}());
exports.default = TextResolver;
